import { Fragment, useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useHttp from "hooks/use-http";

import { Grid } from "@mui/material";

import { getQuestionAnswerRequest } from "api/requests";
import TableCM from "components/shared/Table";
import GenarateHeadCell from "helper/generate-head-cell";
import DrawerCM from "components/shared/Drawer";
import LoadingCM from "components/shared/Loading";
import PaginationCM from "components/shared/Pagination";
import { PAGINATION_LIMIT } from "constants";

const headCells = GenarateHeadCell("question_answer");
let initialPage = 1;

export default function Question() {
  const navigate = useNavigate();
  const { request, loading, setLoading } = useHttp();

  const [page, setPage] = useState(1);
  const [question, setQuestion] = useState({ data: [], count: 0 });

  const getQuestions = useCallback(async () => {
    setLoading(true);
    const res = await request({
      url: getQuestionAnswerRequest,
      values: {
        skip: (page - 1) * PAGINATION_LIMIT,
        limit: PAGINATION_LIMIT,
      },
    });
    setLoading(false);
    if (res) {
      let transformedData = res.data.map((items) => ({
        id: items.id,
        title: items?.text,
        product: items?.product?.title,
        is_confirmed:
          items?.is_confirmed == true ? "تایید شده" : "در انتظار تایید",
      }));
      setQuestion({
        data: transformedData,
        count: res.count,
      });
    }
  }, [page, request]);

  useEffect(() => {
    getQuestions();
  }, [page, getQuestions]);

  return (
    <DrawerCM title="پرسش و پاسخ">
      {loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          <Grid container my={2} spacing={1}>
            <Grid item xs={12} my={2}>
              <TableCM
                title="لیست سوالات"
                rows={question.data}
                headCells={headCells}
                page={page}
                click={(messageId) => navigate("/question-answer/" + messageId)}
              />
            </Grid>
            <PaginationCM
              handleChange={(e, val) => {
                initialPage = val;
                setPage(val);
              }}
              page={page}
              count={question.count}
            />
          </Grid>
        </Fragment>
      )}
    </DrawerCM>
  );
}
